module.exports = __webpack_public_path__ + "static/media/dell.69f12a30.png";